module.exports = __webpack_public_path__ + "media/images/default/pages/business_cooperation/main/3-43799edbe6719261ea7d3701abf65f7f.svg";